export default __webpack_public_path__ + "icehockey-pre.png";